import Quickview from './Quickview';
import RatingStars from '../../utils/RatingStars';
import i18next from 'i18next';
import { truncateString } from '../../utils/truncateString';
import { useEffect, useState } from 'react';
import { fileNotFound } from '../../assets/images/icons';

export default function ProductCard({ item }) {
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;
  const image = item.imgs ? item.imgs : null;
  const productImg = image && image[0] ? localimg + image[0] : null;

  const [shouldRender, setShouldRender] = useState(false);
  const [imgError, setImgError] = useState(false);

  const checkDate = (date) => new Date() - new Date(date) <= 7 * 24 * 60 * 60 * 1000;

  useEffect(() => {
    if (productImg) {
      const img = new Image();
      img.src = productImg;

      img.onload = () => {
        setShouldRender(true);
      };

      img.onerror = () => {
        setImgError(true);
        setShouldRender(true);
      };
    } else {
      setShouldRender(true);
    }
  }, [productImg]);

  if (!shouldRender) {
    return (
      <div className="w-full max-w-sm rounded-lg shadow bg-white">
      </div>
    );
  }

  return (
    <div className="relative group">
      <div className="relative overflow-hidden aspect-square">
        <img loading="lazy"
          className="object-cover w-full h-full transition-all duration-300"
          alt="product"
          src={imgError || !productImg ? fileNotFound : productImg}
        />
        <div className="absolute inset-0 flex bg-white/20 backdrop-blur-sm items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <Quickview slugProduct={item.slug} />
        </div>
      </div>
      <div className="absolute left-3 top-3 max-sm:left-2 max-sm:top-2">
        <p className={`sm:px-3 sm:py-1.5 px-1.5 py-1 text-[8px] sm:text-xs font-bold tracking-wide uppercase rounded-full
           ${checkDate(item.date) ? 'text-black bg-white' : 'text-white bg-black'}`}>
          {checkDate(item.date) ? 'New' : 'Sale'}
        </p>
      </div>
      <div className="flex items-start justify-between mt-2 space-x-4">
        <div>
          <h3 className="max-sm:text-xs text-sm font-bold text-gray-900 md:text-base">
            <a href={`product/${item.slug}`} className='hover:underline' data-tooltip-id="my-tooltip" data-tooltip-content={item.name[i18next.language]}>
              {truncateString(item.name[i18next.language], 24)}
            </a>
          </h3>
          <div className="flex items-center mt-1 space-x-px">
            {
              item.ratings > 5 ?
                <RatingStars rating={item.ratings} size='12px' color='black' />
                : <p className='text-xs max-sm:text-[10px] text-black/60 leading-none'>
                  {item.category[i18next.language]}
                </p>
            }
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm font-bold text-gray-900 md:text-base">{item.price} MAD</p>
        </div>
      </div>
    </div>
  );
}
